import * as React from 'react';
import { NavLink, RouteComponentProps, withRouter } from 'react-router-dom';
import '../../styles/main.less';
import './styles.less';

interface IProps extends RouteComponentProps<any> {
	className?: string;
}

class _Footer extends React.PureComponent<IProps> {
	public render() {
		return (
			<div className='footerContainer'>
				<div className='footer-LogoContainer'>
					<div className='footer-Logo' />
					<div>Copyright &copy; 2019 Real Magic, Inc.</div>
					<div>
						<NavLink
							className='footerLink'
							to='/privacy'
						>
							Privacy Policy
						</NavLink>
						<NavLink
							className='footerLink'
							to='/terms'
						>
							Terms of Service
						</NavLink>
					</div>
				</div>
				<div className='footer-contactInfoContainer'>
					Real Magic, Inc.<br />
					2409 Crabtree Blvd, Suite 107<br />
					Raleigh, NC 27604<br />
					<a className='footerLink' href='tel:18882537050'>1-888-253-7050</a><br />
					<a className='footerLink' href='mailto:support@levitateapp.com'>support@levitateapp.com</a>
				</div>
			</div>
		);
	}
}

export const Footer = withRouter(_Footer);
